import React, {Component} from "react";
import './KitCutLaboSection.css';
import KitCutLogo from "../../../../assets/img/kitcut_logo.png";

class KitCutLaboSection extends Component {

    render() {
        return (
            <div className="row lab-o-section-row ">
                {/*<div className="lab-o-section-row-2 no-margin-labo">
                    <div className="col-md-1"></div>
                   <div className="col-md-3 lab-o-section-label-1-sub-text">
                       <span className="lab-o-section-label-1">KIT</span><br/>
                       <span className="lab-o-section-label-1-sub-text">開発のためのプロトタイプ</span>
                   </div>
                   <div className="col-md-1 lab-o-section-label-2"> &#10005;</div>
                   <div className="col-md-3 lab-o-section-label-1-sub-text">
                       <span className="lab-o-section-label-1">CUT</span><br/>
                       <span className="lab-o-section-label-1-sub-text">[コスト]を削減する</span>
                   </div>
                    <div className="col-md-1 lab-o-section-label-2"> &#10005;</div>
                   <div className="col-md-3 lab-o-section-label-1-sub-text">
                       <span className="lab-o-section-label-1">LABO</span><br/>
                       <span className="lab-o-section-label-1-sub-text">研究室・実験室</span>
                   </div>
                </div>*/}
                <div className="row kit-cut-labo-row">
                    <div className="col-md-4 lab-o-section-label-1">
                        <div className="text-right kit-label">KIT</div>
                        <div className="lab-o-section-label-1-sub-text-1">開発のためのプロトタイプ</div>
                    </div>
                    <div className="row col-md-4">
                        <div className="col-md-3 lab-o-section-label-2">&#10005;</div>
                        <div className="col-md-6 lab-o-section-label-1 text-center">CUT
                            <br/>
                            <div className="lab-o-section-label-1-sub-text">[コスト]を削減する</div>
                        </div>
                        <div className="col-md-3 lab-o-section-label-2">&#10005;</div>

                    </div>
                    <div className="col-md-4 lab-o-section-label-1 labo-label text-left">
                        LABO
                        <br/>
                        <div className="lab-o-section-label-1-sub-text-3">研究室・実験室</div>
                    </div>
                </div>

                <div className="lab-o-section-logo-row">
                    <img className="kitcut-logo-section2" src={KitCutLogo} alt="KITCUT"/>
                </div>

                <div className="lab-o-section-text-row">
                    <span>
                        日本のハードウェア・スタートアップが抱える問題点を解決する
                    </span><br/>
                    <span> &nbsp;&nbsp;スピーディーかつ小回りの効くGLOBALな開発環境を提供します。
                    </span>
                </div>
            </div>

        );
    }
}

export default KitCutLaboSection;



// WEBPACK FOOTER //
// ./src/components/Site/HomeContent/KitCutLaboSection/KitCutLaboSection.js